module.exports = __webpack_public_path__ + "img/tit1.005547ca.png";